import { Injectable } from '@angular/core';
import { RewardsProgramGateway } from '@domain/models/reward/gateway/rewards-program.gateway';
import { catchError, map, Observable, of } from 'rxjs';
import { RewardBalance, RewardToken } from '@domain/models/reward/reward-balance.model';
import { environment } from '@environments/environment';
import { AlertService } from '../alert-service/alert.service';
import { HttpClient } from '@angular/common/http';
import { AlertPosition, AlertType } from '@domain/enums/alert/alert-type.enum';

@Injectable({
  providedIn: 'root',
})
export class RewardsProgramService extends RewardsProgramGateway {
  constructor(
    private _alertService: AlertService,
    private _http: HttpClient
  ) {
    super();
  }

  getBalance(userId?: number): Observable<RewardBalance> {
    this._alertService.setLoading(true);
    return this._http.get<RewardBalance>(`${environment.memberPortalServiceURL.replace('{{brandDomain}}', window.location.host)}/rewards-program/balance?userId=${userId}`).pipe(
      map((rewardBalance: RewardBalance) => {
        this._alertService.setLoading(false);
        return rewardBalance;
      }),
      catchError((e) => {
        console.log(e);
        this._alertService.setLoading(false);
        this._alertService.showAlert({
          type: AlertType.Error,
          title: 'Error',
          description: e?.error?.Message,
          position: AlertPosition.TopCenter,
        });
        return of();
      })
    );
  }

  getToken(userId?: number): Observable<RewardToken> {
    this._alertService.setLoading(true);
    return this._http.get<RewardToken>(`${environment.memberPortalServiceURL.replace('{{brandDomain}}', window.location.host)}/rewards-program/token?userId=${userId}`).pipe(
      map((rewardToken: RewardToken) => {
        this._alertService.setLoading(false);
        return rewardToken
      }),
      catchError((e) => {
        console.log(e);
        this._alertService.setLoading(false);
        this._alertService.showAlert({
          type: AlertType.Error,
          title: 'Error',
          description: e?.error?.Message,
          position: AlertPosition.TopCenter,
        });
        return of()
      })
    );
  }
}
